import permissions from "@/router/userPermissions";

export default [
  {
    path: "asset-values/regenerate-historical-prices",
    name: "assetValuesRegenerateHistoricalPrices",
    component: () => import("@/modules/hollymontt-admin/views/AssetValuesRegeneratePrices.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Regenerar precios históricos",
    },
  },
  {
    path: "asset-values/deactivate",
    name: "assetValuesDeactivate",
    component: () => import("@/modules/hollymontt-admin/views/AssetValuesDeactivate.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Desactivar activos",
    },
  },
  {
    path: "asset-values/splits",
    name: "assetValuesSplits",
    component: () => import("@/modules/hollymontt-admin/views/AssetValuesSplits.vue"),
    meta: {
      auth: permissions.scopes.admin,
      title: "Splits de activos",
    },
  },
];
